import { Stack, Typography } from '@mui/material';
import MapsUgcOutlinedIcon from '@mui/icons-material/MapsUgcOutlined';

export default function NoChatPlaceHolder() {
  return (
    <Stack justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
      <MapsUgcOutlinedIcon sx={{ width: 64, height: 64 }} />
      <Typography sx={{ mt: 2 }}>اولین گفت‌وگوی خود را ایجاد کنید!</Typography>
    </Stack>
  );
}
